import React, { useState } from "react";
import style from "./smsconset.module.css";
const SmsConsetForm = () => {
    const [smsConsentChecked, setSmsConsentChecked] = useState(false);
    const [smsConsentError, setSmsConsentError] = useState("");
    const [showInfo, setShowInfo] = useState(false);
    return (
        <div className="container">
            <div className={style.smsConsentBox}>
                <h2 className={style.twilioHeading}>
                    SMS Consent Proof for FundLife.Me Registration
                </h2>

                <p className={style.twilioSubText}>
                    This page shows the exact SMS consent language used in our live user registration flow.
                </p>

                <label className={style.smsCheckboxLabel}>
                    <input
                        type="checkbox"
                        checked={smsConsentChecked}
                        onChange={(e) => {
                            setSmsConsentChecked(e.target.checked);
                            setSmsConsentError("");
                        }}
                        className={style.checkboxtwilio}
                    />

                    <span>
                        OPTIONAL: I agree to receive text message updates from FundLife.Me
                        about my campaign progress at the phone number provided.
                        Subscription to text messaging is not required to create or run a campaign.
                    </span>
                </label>

                <span className={style.twiliostop}>
                    You may receive up to 7 messages per month.
                </span>

                <br />

                <span className={style.twiliostop}>
                    Message and data rates may apply. Reply HELP for help or STOP to cancel.
                </span>

                <br />

                <span className={style.twiliostop}>
                    This consent language is identical to the live registration flow used by all users.
                </span>

                <br />
                <div className={style.maininformationtwilio}>

                    <div className={style.termsSeparate}>
                        <a
                            href="https://fundlife.me/termofservice"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={style.termsLink}
                        >
                            Review our Terms and Conditions
                        </a>
                        <br></br>
                        <a
                            href="https://fundlife.me/privacy"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={style.termsLink}
                        >
                            Review our Privacy Policy
                        </a>
                    </div>

                    <div className={style.twilioInfoContainer}>
                        <span
                            className={style.twilioInlineInfo}
                            onClick={() => setShowInfo((prev) => !prev)}
                        >
                            ⓘ
                        </span>

                        {showInfo && (
                            <span className={style.twilioInlinePopup}>
                                These messages include reminders to complete onboarding,
                                notifications about activity on your fundraising page,
                                and encouragement to share your campaign.
                                You can opt out at any time.
                            </span>
                        )}
        </div>
                </div>
                     <button className={style.twilioProofButton} disabled>
                            Continue
                        </button>
               
            </div>
        </div>
    )

}

export default SmsConsetForm;